import { ReactNode } from "react";
import { Button } from "@/shared/ui/button";
import { LucideIcon } from "lucide-react";
import { cn } from "@/shared/lib/utils";

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
    icon?: LucideIcon;
  };
  illustration?: ReactNode;
  className?: string;
}

export const EmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  illustration,
  className,
}: EmptyStateProps) => {
  return (
    <div className={cn(
      "flex flex-col items-center justify-center text-center py-12 px-4 animate-fade-in",
      className
    )}>
      {/* Illustration or Icon with floating animation */}
      {illustration ? (
        <div className="mb-6 animate-float">
          {illustration}
        </div>
      ) : Icon ? (
        <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-6 animate-float">
          <Icon className="w-8 h-8 text-muted-foreground" />
        </div>
      ) : null}

      {/* Title */}
      <h3 className="text-lg font-semibold text-foreground mb-2">
        {title}
      </h3>

      {/* Description */}
      <p className="text-sm text-muted-foreground max-w-sm mb-6">
        {description}
      </p>

      {/* Action Button with attention pulse */}
      {action && (
        <Button
          onClick={action.onClick}
          variant="default"
          className="animate-attention-pulse hover:animate-none"
        >
          {action.icon && <action.icon className="w-4 h-4 mr-2" />}
          {action.label}
        </Button>
      )}
    </div>
  );
};
